import { RangeSlider } from '@shopify/polaris';
import * as React from 'react';
import { memo } from 'react';

export type VideoFragmentDynamicSliderProps = {
  initialStartTime?: number;
  initialEndTime?: number;
  duration: number;
  onSliderChange: (newStart: number, newEnd: number) => void;
};

const VideoFragmentDynamicSlider = ({
  initialStartTime,
  initialEndTime,
  duration,
  onSliderChange,
}: VideoFragmentDynamicSliderProps) => {
  const [startTime, setStartTime] = React.useState(initialStartTime || 0);
  const [endTime, setEndTime] = React.useState(initialEndTime || duration);

  const onValueChange = ([newStart, newEnd]: number[]) => {
    setStartTime(newStart);
    setEndTime(newEnd);
    onSliderChange(newStart, newEnd);
  };

  const selectedFragmentLabel = `Selected fragment: ${startTime.toFixed(1)}s -
          ${Math.min(endTime, duration).toFixed(1)}s`;
  return (
    <RangeSlider
      label={selectedFragmentLabel}
      value={[startTime, endTime]}
      min={0}
      max={duration}
      step={0.1}
      onChange={onValueChange as any}
    />
  );
};

export default memo(VideoFragmentDynamicSlider);
